<div class="modal-header">
    <h5 class="modal-title">{{modalTitle}}</h5>
    <button type="button" class="close" (click)="oncloseModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1" [loaderId]="loaderId"
        [bgsPosition]="'center-center'">
    </ngx-ui-loader>
    <div class="row">
        <div class="col-md-12 grid-margin stretch-card">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div class="form-check form-check-flat form-check-primary">
                    </div>
                    <div class="d-flex align-items-center flex-wrap text-nowrap status-icon-container">
                        <div ngbDropdown class="mb-2">
                            <button ngbDropdownToggle *ngIf="dropdownBtn" class="btn p-0 no-dropdown-toggle-icon" type="button"
                                id="dropdownMenuButtonmodalWidgetSPCustomer2">
                                <i class="icon-lg text-muted pb-5px" data-feather="menu" appFeatherIcon></i>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdownMenuButtonmodalWidgetSPCustomer2"
                                class="menu-style">
                                <a ngbDropdownItem *ngIf="isShowLabel || isShowLabeltransaction" class="d-flex align-items-center" href="" (click)="onviewBySummary($event)">
                                    <i data-feather="eye" appFeatherIcon class="icon-sm mr-2"></i> 
                                    <span class="">View by Trend</span>
                                </a>
                                <a ngbDropdownItem *ngIf="isShowCustomer" class="d-flex align-items-center" href="" (click)="onviewByCustomer($event)">
                                    <i data-feather="eye" appFeatherIcon class="icon-sm mr-2"></i> <span class="">View by
                                      Customer</span>
                                  </a>
                                <a ngbDropdownItem *ngIf ='isShowSalesPerson' class="d-flex align-items-center" href="" (click)="onSalesperson($event)">
                                    <i data-feather="eye" appFeatherIcon class="icon-sm mr-2"></i> 
                                    <span class="">View by Salesperson</span>
                                </a>
                                <a ngbDropdownItem *ngIf="isShowDevice"  class="d-flex align-items-center" href="" (click)="onDeviceType($event)">
                                    <i data-feather="eye" appFeatherIcon class="icon-sm mr-2"></i> <span class="">View by
                                      Device Type</span>
                                </a>
                                <a ngbDropdownItem *ngIf="isShowLabeltransaction && isCardShow" class="d-flex align-items-center" href="" (click)="onCardType($event)">
                                    <i data-feather="eye" appFeatherIcon class="icon-sm mr-2"></i> <span class="">View by Card
                                      Type</span>
                                </a>
                                <a ngbDropdownItem *ngIf="isShowLabeltransaction" class="d-flex align-items-center" href="" (click)="onviewByChannel($event)">
                                    <i data-feather="eye" appFeatherIcon class="icon-sm mr-2"></i> <span class="">View by
                                      Channel</span>
                                </a>
                                <a ngbDropdownItem *ngIf="isShowLabeltransaction && isShowMode" class="d-flex align-items-center" href="" (click)="onviewByMode($event)">
                                    <i data-feather="eye" appFeatherIcon class="icon-sm mr-2"></i> <span class="">View by
                                      Mode</span>
                                </a>
                                <a ngbDropdownItem *ngIf="isShowLabeltransaction && isShowprocessor" class="d-flex align-items-center" href="" (click)="onviewByProcessor($event)">
                                    <i data-feather="eye" appFeatherIcon class="icon-sm mr-2"></i> <span class="">View by Processor</span>
                                </a>
                                <a ngbDropdownItem *ngIf="isShowLabel && isGeoLocation" class="d-flex align-items-center" href="" (click)="onLocation($event)">
                                    <i data-feather="eye" appFeatherIcon class="icon-sm mr-2"></i> 
                                    <span class="">View by Geo-location</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <apx-chart *ngIf="isChart2Show" [series]="apexChart2Show.series" [chart]="apexChart2Show.chart"
                    [dataLabels]="apexChart2Show.dataLabels" [plotOptions]="apexChart2Show.plotOptions"
                    [responsive]="apexChart2Show.responsive" [xaxis]="apexChart2Show.xaxis" [title]="apexChart2Show.title"
                    [legend]="apexChart2Show.legend" [fill]="apexChart2Show.fill" [labels]="apexChart2Show.labels"
                    [colors]="apexChart2Show.colors" [grid]="apexChart2Show.grid"
                    [tooltip]="apexChart2Show.tooltip"></apx-chart>
        
                <apx-chart *ngIf="isChartShow" [series]="apexChartSPCustomers.series" [chart]="apexChartSPCustomers.chart"
                    [dataLabels]="apexChartSPCustomers.dataLabels" [plotOptions]="apexChartSPCustomers.plotOptions"
                    [responsive]="apexChartSPCustomers.responsive" [xaxis]="apexChartSPCustomers.xaxis" [title]="apexChartSPCustomers.title"
                    [legend]="apexChartSPCustomers.legend" [fill]="apexChartSPCustomers.fill" [labels]="apexChartSPCustomers.labels"
                    [colors]="apexChartSPCustomers.colors" [grid]="apexChartSPCustomers.grid"
                    [tooltip]="apexChartSPCustomers.tooltip"></apx-chart>
                <zingchart-angular *ngIf="isStateShow" [config]="configUSChart" [height]="500"></zingchart-angular>
                <div *ngIf='isChart2Show || show12Month'>
                    <p (click)=" toggleCharts()" style="cursor: pointer; font-weight: bold;" align="right">
                        <a>{{ isChartShow ? 'View by devices' : swapLabel }}</a> >>>                        
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>